import { FC } from 'react';
import { Link } from '@blueprint/ui';

import triggerTracking from '@blueprint/tracking/dist/Tracking';

import RegisterForm from './RegisterForm';
import { TermsText } from '../../AuthModal.styles';
import { SocialAuthProps } from '../../AuthModal.types';

const RegisterSection: FC<SocialAuthProps> = ({
    close,
    actionAfterAuth,
    resetActionAfterAuth,
    onSocialAuth
}) => (
    <>
        <RegisterForm
            close={close}
            actionAfterAuth={actionAfterAuth}
            resetActionAfterAuth={resetActionAfterAuth}
            onSocialAuth={onSocialAuth}
        />
        <TermsText size="secondary">
            By registering you accept our <br key="linebreak" />{' '}
            <Link
                key="terms"
                data-testid="terms-link"
                href="/terms/"
                onClick={() => {
                    triggerTracking({
                        event: 'GAEvent',
                        eventCategory: 'registration',
                        eventAction: 'click_to_terms',
                        eventLabel: actionAfterAuth?.eventLabel
                    });
                }}
            >
                Terms of Use
            </Link>{' '}
            and{' '}
            <Link
                key="privacy"
                data-testid="privacy-link"
                href="/privacy/"
                onClick={() => {
                    triggerTracking({
                        event: 'GAEvent',
                        eventCategory: 'registration',
                        eventAction: 'click_to_privacy',
                        eventLabel: actionAfterAuth?.eventLabel
                    });
                }}
            >
                Privacy Policy
            </Link>
            .
        </TermsText>
    </>
);

export default RegisterSection;
